module.exports = __webpack_public_path__ + "static/media/SangBleuSans-Regular-WebS.7b3e7c47.woff";